// Regler (Rules) page - explains the rules and guidelines of Kulinarisk Laug club
// Users can expand/collapse sections to read different rules

import React, { useState } from "react";
import { Link } from "react-router-dom";
import BlaturRegler from "./BlaturRegler";

const Regler = () => {
  // State to track which section is expanded (open)
  const [openSection, setOpenSection] = useState(null);

  // Function to toggle a section open/closed when user clicks
  const toggleSection = (index) => {
    // If the clicked section is already open, close it. Otherwise, open it.
    setOpenSection(openSection === index ? null : index);
  };

  return (
    <div className="regler-page">
      <h1 className="regler-title">🧾 Kulinarisk Laug – Regler</h1>
<br></br>

      {/* Section 1: Generelt (General Rules) */}
      <div className="section">
        <h2>1. Generelt</h2>
        <p>
          Alle medlemmer blir inkludert i medlemslista her på nettsiden og 
          blir invitert til alle følgende eventer; Vino🍷, KL🥩 og Blåtur🌍. 
          Deltakelse er frivillig. Vi registrerer alle eventer, vertskap og deltakelse på denne nettsiden. 
          Dersom du deltar på et event så godtar du samtidig muligheten for å bli utnevnt som 
          neste arrangør av denne typen event.
        </p>
        <div className="sub-section">
          <button className="sub-header" onClick={() => toggleSection(1)}>
            1.1 Utnevnelse av neste arrangør
          </button>
          {/* Show content only if this section is open */}
          <div className={`sub-content ${openSection === 1 ? "open" : ""}`}>
            <p>
              Mot slutten av hvert event skal det gjennomføres en tilfeldig
              trekning av neste arrangør mellom de som er fysisk til stede.
              Dersom et medlem har arrangert akkurat denne typen event ila. de
              siste 12 månedene, så har vedkommende obligatorisk fritak fra
              trekningen. Det medlemmet som blir utnevnt kan ikke trekke seg,
              men kan avtale med et annet medlem å gi videre ansvaret. Uansett
              hvem som arrangerer neste event så må dette gjøres innen
              tidsfristen til denne typen event.
            </p>
          </div>
        </div>

        <div className="sub-section">
          <button className="sub-header" onClick={() => toggleSection(2)}>
            1.2 Kåringer og utmerkelser
          </button>
          {/* Show content only if this section is open */}
          <div className={`sub-content ${openSection === 2 ? "open" : ""}`}>
            <p>
              “Beste arrangør” og “Beste deltaker” er et live scoreboard der
              hvert medlem får poeng for å arrangere og for å delta. 
              Antall poeng varierer ut ifra hvilken type event, men er samme for arrangering og deltakelse:
            </p>
            <ul>
              <li>Vino🍷 = 4 poeng</li>
              <li>KL🥩 = 4 poeng</li>
              <li>Blåtur🌍 = 7 poeng</li>
            </ul>
            <p>
              Innenfor disse kåringene har vi også visse utmerkelser som gis
              basert på nevneverdige tiltak, initiativ og engasjement.
            </p>
          </div>
        </div>

        <div className="sub-section">
          <button className="sub-header" onClick={() => toggleSection(3)}>
            1.3 Nye medlemmer
          </button>
          <div className={`sub-content ${openSection === 3 ? "open" : ""}`}>
            <p>
              For å delta på event (Vino🍷, KL🥩 eller Blåtur🌍) uten å være medlem, må man først 
              motta en invitasjon fra et medlem. Alle medlemmer står fritt til å invitere med hvem 
              som helst uten å si ifra til andre medlemmer på forhånd. Medlemmet som inviterer, 
              må i så fall gi beskjed til arrangøren av det relevante eventet. Kriteriet er at den 
              nye personen har lest og forstått denne siden med regler, samt ønsker å bli medlem. 
              Det er også et kriterium at medlemmet som har invitert denne personen introduserer vedkommende 
              med en skål på eventet. Etter dette er vedkommende offisielt medlem. 
            </p>
          </div>
        </div>
      </div>

      {/* Section 2: Type arrangementer */}
      <div className="section">
        <h2>2. Type arrangementer</h2>
          <p>Hovedprinsipper er: Alle medlemmer blir invitert. 
          Deltakelse er frivillig. Dersom man deltar er arrangøransvar en del av gamet. </p>
        <div className="sub-section">
          <button className="sub-header" onClick={() => toggleSection(4)}>
            2.1 Vino🍷
          </button>
          <div className={`sub-content ${openSection === 4 ? "open" : ""}`}>
            <p>
              Vino🍷 arrangeres kvartalsvis, dvs. fire ganger i året. 
              Det skal være fokus på vinsmaking og -kunnskap. Arrangøren velger seg et tema innenfor vin, 
              setter seg inn i dette og lærer dette videre til deltakerne. 
            </p>
          </div>
        </div>

        <div className="sub-section">
          <button className="sub-header" onClick={() => toggleSection(5)}>
            2.2 KL🥩
          </button>
          <div className={`sub-content ${openSection === 5 ? "open" : ""}`}>
            <p>
              KL🥩 arrangeres kvartalsvis, dvs. fire ganger i året. 
              Det skal være fokus på mat, drikke og stemning. Arrangøren velger et sted/restaurant og booker bord der.
            </p>
          </div>
        </div>

        <div className="sub-section">
          <button className="sub-header" onClick={() => toggleSection(6)}>
            2.3 Blåtur🌍
          </button>
          <div className={`sub-content ${openSection === 6 ? "open" : ""}`}>
            {/* Same rules as on the blåtur page (single source: blaturRules.js) */}
            <BlaturRegler />
            <p><Link to="/blatur">Se turene og invitasjonslisten på blåtur-siden →</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Regler;
